module.exports = __webpack_public_path__ + "static/media/whatsIcon.9dd2848b.gif";